import { render, staticRenderFns } from "./SavedImportantData.vue?vue&type=template&id=7c84980e&scoped=true"
import script from "./SavedImportantData.vue?vue&type=script&lang=js"
export * from "./SavedImportantData.vue?vue&type=script&lang=js"
import style0 from "./SavedImportantData.vue?vue&type=style&index=0&id=7c84980e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c84980e",
  null
  
)

export default component.exports